/**
 * documentationService.ts
 * Feature: 041-documentation-backend
 * Author: Peter Dobler
 * Date: 2026-05-15
 * Constitution Version: 1.12.0
 *
 * Purpose: API client functions for documentation categories and runbooks.
 */

import { apiClient } from './apiClient';
import type { DocCategory } from '../pages/Help/DocumentationPage';
import type { Runbook, RunbookSeverity } from '../pages/Help/RunbooksPage';

const BASE_PATH = '/api/documentation';

export async function getDocCategories(): Promise<DocCategory[]> {
  const response = await apiClient.get<{ data: DocCategory[] }>(`${BASE_PATH}/categories`);
  return response.data.data;
}

export async function getRunbooks(severity?: RunbookSeverity): Promise<Runbook[]> {
  const url = severity
    ? `${BASE_PATH}/runbooks?severity=${encodeURIComponent(severity)}`
    : `${BASE_PATH}/runbooks`;
  const response = await apiClient.get<{ data: Runbook[] }>(url);
  return response.data.data;
}
